import React from "react";

export const DateBodyTemplate = (rowData: any) => {
  return <div>{new Date(rowData.createDate || "").toLocaleString()}</div>;
};
